var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('invoiceListingComponent',{attrs:{"invoiceList":_vm.invoiceList,"invoiceStages":_vm.invoiceStages,"smallScreen":_vm.forLargeScreen},on:{"stageFilter":_vm.stageFilter,"newInvoice":_vm.triggerNewInvoice,"triggerPreview":_vm.triggerPreview}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }